export enum PPCPageLoadExperienceKeys {
  DetailPage = 'detail-page',
  AccountBalancePage = 'account-balance-page',
  InvoicesPage = 'invoices-page',
  InvoiceDetailsPage = 'invoice-details-page',
  ConfirmPaymentPage = 'confirm-payment-page',
  RefundsPage = 'refunds-page',
  SubscriptionsPage = 'subscriptions-page',
  CatalogPage = 'catalog-page',
  EntitlementPage = 'entitlement-page',
  SearchPage = 'search-page',
  CustomerAddressPage = 'customer-address-page',
  BillingProfileDetailsPage = 'billing-profile-details-page',
  CustomerAddressDetailPage = 'customer-address-detail-page',
  CloudSitePage = 'cloud-site-page',
  GenericErrorPage = 'generic-error-page',
  UnauthorizedErrorPage = 'unauthorized-error-page',
  KnownServerErrorPage = 'known-server-error-page',
  NotFoundErrorPage = 'not-found-error-page',
  ImportSubscriptionPage = 'import-subscription-page',
  OrderDetailPage = 'order-detail-page',
  AddPaymentMethodPage = 'add-payment-method-page',
  ComingSoonPage = 'coming-soon-page',
  CreditDetailsPage = 'credit-details-page',
  EmailPage = 'email-page',
  HomePage = 'home-page',
  QuotesPage = 'quotes-page',
  QuoteDetailPage = 'quote-details-page',
  OrderPage = 'order-page',
  NotificationPreferencePage = 'notification-preference-page',
  OrganisationDetailPage = 'organisation-detail-page',
  InternalLicensesPage = 'internal-licenses-page',
  DealRegistrationsPage = 'deal-registrations-page',
}
